<template>
    <div class="white--text mx-5 my-2" style="position:absolute;top:0;z-index:1">
        <a @click="$router.go(-1)"><v-icon dark>mdi-arrow-left</v-icon></a>
    </div>
</template>
<script>
export default {
    name: "BackButton",
    data() {
        return {
            
        }
    }
}
</script>